<div
  *ngIf="popup()"
  class="popup"
  [ngClass]="popupPosition()"
>
  <div [class]="popupClasses()">
    <div class="flex items-center gap-2">
      <ng-container *ngIf="popup()?.icon">
        <img [src]="popup()?.icon" alt="icon" class="w-6 h-6" />
      </ng-container>
      <span class="font-medium text-base leading-6 text-white">{{ popup()?.message | translate}}</span>
    </div>
    <!-- <button
      class="ml-2 text-white hover:text-gray-200"
      (click)="closePopup()"
    >
      ✕
    </button> -->
  </div>
</div>
